export interface MandateObj {
    amount: string
    actype: string
    mandateType: string
    clientCode: string
    ifscCode: string
    accountNo: string
    bankName: string
    portfolioId: string
    startDate: string
    endDate: string
  }

  export const SAVING_MANDATE_SUCCESS = "SAVING_MANDATE_SUCCESS";